import React, { FC, ReactNode } from 'react';
import styles from './LinkButton.module.css';

interface LinkButtonProps {
  onClick: () => void;
  children: ReactNode;
}

/** Inline, link-styled button for actions embedded in running text (e.g. "please try again or contact SST"). */
export const LinkButton: FC<LinkButtonProps> = ({ onClick, children }) => {
  return (
    <button type="button" className={styles.linkButton} onClick={onClick}>
      {children}
    </button>
  );
};
